import { Form, Input, ModalProps, FormProps, Modal, InputNumber, useSelect, Select } from '@pankod/refine-antd'
import { useGetIdentity } from '@pankod/refine-core'
import { ICompetency } from 'interfaces'

type CreateAspectProps = {
  modalProps: ModalProps
  formProps: FormProps
}

export const CreateAspect: React.FC<CreateAspectProps> = ({ modalProps, formProps }) => {
  const { data: user } = useGetIdentity()
  const { selectProps: competencySelectProps } = useSelect<ICompetency>({
    resource: 'competencies',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })

  return (
    <Modal {...modalProps} title="Create Aspect">
      <Form {...formProps} size="large" layout="vertical">
        <Form.Item
          label="Id"
          name="aspects_id"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Competency Aspect Name"
          name="name"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="Competency" name="competency_id" rules={[{ required: true }]}>
          <Select {...competencySelectProps} />
        </Form.Item>
        <Form.Item name="created_by" initialValue={user?.id}>
          <Input type="hidden" />
        </Form.Item>
      </Form>
    </Modal>
  )
}
